import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

@Pipe({
  name: 'imagecheck'
})
export class ImagecheckPipe implements PipeTransform {
  

  constructor(private http: HttpClient) {}

  transform(url: string) :any {
    let defaultImage: string = url;
    let img = new Image();
    img.onabort  = function(){
      defaultImage="http://www.fondation.org.ma/assets/images/icon-book.png";
    }
    img.src = url;
    return defaultImage;
  }

}
